import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Radio from "@mui/material/Radio";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import KeyboardVoiceOutlinedIcon from "@mui/icons-material/KeyboardVoiceOutlined";
import Button from "@mui/material/Button";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { unicodeToString } from "../../../Js/Common";
import OptionMedia from "../../../Components/Card/AssetUI/OptionMedia";
import StatusIndicator from "../../../Components/Card/AssetUI/StatusIndicator";
import { checkSBCorrectAnswerPresentation } from "../../../Js/CheckCorrectAnswers";
import Confirmation from "../../../Components/Modal/Confirmation";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const SB = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  let [userAnswer, setUserAnswer] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [currentIndexPlay, setCurrentIndexPlay] = useState([]);
  let [isPresentation, setIsPresentation] = useState([]);
  let [actualAnswer, setActualAnswer] = useState([]);
  let [localAlertFlag, setLocalAlertFlag] = useState(false);
  let [localCorrect, setLocalCorrect] = useState([]);
  let [localSubmitButton, setLocalSubmitButton] = useState([]);
  let [localShowAnswer, setLocalShowAnswer] = useState([]);
  let [localAttempStatus, setLocalAttempStatus] = useState([]);
  let [localCurrentIndex, setLocalCurrentIndex] = useState(0);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } =
    useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (props.content) {
      setUserAnswer(
        new Array(props.content.epage.options.content.length).fill([])
      );
      setLocalCorrect(
        new Array(props.content.epage.options.content.length).fill(false)
      );
      setLocalSubmitButton(
        new Array(props.content.epage.options.content.length).fill(true)
      );
      setLocalShowAnswer(
        new Array(props.content.epage.options.content.length).fill(false)
      );
      setLocalAttempStatus(
        new Array(props.content.epage.options.content.length).fill(false)
      );
      setIsPresentation(props.content.info.is_presentation);
      dispatch(
        currentAssetSliceActions.setCurrentAttemptData(
          new Array(props.content.epage.options.content.length).fill([])
        )
      );
      let actualAnswers = props.content.epage.options.content.map((val) => {
        return val.answer;
      });
      setActualAnswer(actualAnswers);
      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswers,
      });
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
  }, [logObj]);

  useEffect(() => {
    setUserAnswer(
      new Array(props.content.epage.options.content.length).fill([])
    );
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    dispatch(
      currentAssetSliceActions.setCurrentAttemptData(
        new Array(props.content.epage.options.content.length).fill([])
      )
    );
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      setUserAnswer(assetLogObj.actualAnswer);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  const updateUserAnswer = (innerIndex, outerIndex) => {
    if (!showAnswer && !attempted) {
      let mainArr = [...userAnswer];
      let arr = [...userAnswer[outerIndex]];
      let pos = arr.indexOf(innerIndex);
      if (pos == -1) {
        arr.push(innerIndex);
      } else {
        arr.splice(pos, 1);
      }
      mainArr[outerIndex] = arr;
      setUserAnswer(mainArr);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(mainArr));
    }
  };

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  const internalSubmit = (index) => {
    //let checkSBCorrectAnswerPresentation
    setLocalCurrentIndex(index);
    if (localSubmitButton[index]) {
      let ans = checkSBCorrectAnswerPresentation(
        userAnswer[index],
        actualAnswer[index],
        index
      );
      let attemtedStatusHere = [...localAttempStatus];
      attemtedStatusHere[index] = ans.attempted;
      setLocalAttempStatus(attemtedStatusHere);
      setLocalAlertFlag(true);
      if (ans.attempted) {
        let showansweHere = [...localShowAnswer];
        let correctHere = [...localCorrect];
        if (+ans.score == 1) {
          correctHere[index] = true;
          showansweHere[index] = false;
        } else {
          correctHere[index] = false;
          showansweHere[index] = true;
        }
        setLocalShowAnswer(showansweHere);
        setLocalCorrect(correctHere);
        let submitHere = [...localSubmitButton];
        submitHere[index] = false;
        setLocalSubmitButton(submitHere);
      }
    } else {
      let useransHere = [...userAnswer];
      useransHere[index] = actualAnswer[index];
      setUserAnswer(useransHere);
      let showansweHere = [...localShowAnswer];
      showansweHere[index] = false;
      setLocalShowAnswer(showansweHere);
    }
  };

  return (
    <>
      {props.content && (
        <Grid item xs={12} sx={{}}>
          <Box
            sx={{
              border: 1,
              borderColor: "#EAECEE",
              borderRadius: 5,
              py: 2,
              mx: 6,
              mt: 1,
              height: "58vh",
              overflow: "auto",
            }}
             
          >
            <Grid
              container
              sx={{
                flexDirection: "row",
                flexFlow: "wrap",
                justifyContent: "center",
                px: 2,
                gap: 1,
              }}
            >
              <Grid item xs={12}>
                {props.content.epage.options.content.map((val, index) => {
                  return (
                    <Box
                      dense
                      sx={{
                        borderBottom: 1,
                        borderBottomColor: "#EFEFEF",
                        padding: 0,
                        my: 2,
                        display: "inline-flex",
                        width: "100%",
                      }}
                    >
                      {optionWiseAns && optionWiseAns.length > 0 && (
                        <StatusIndicator
                          correct={optionWiseAns[index]}
                        ></StatusIndicator>
                      )}
                      {val && val.media && (
                        <OptionMedia
                          media={val.media}
                          isPlaying={currentIndexPlay[index]}
                          setPlayMode={(status, end) => {
                            setPlayMode(status, index, end);
                          }}
                        ></OptionMedia>
                      )}
                      <Grid container sx={{ pb: 1, alignItems: "center" }}>
                        <Grid
                          item
                          xs={isPresentation ? 10 : 12}
                          sx={{
                            paddingLeft: 2,
                            paddingTop: 1,
                            display: "inline-flex",
                          }}
                        >
                          {unicodeToString(val.text)
                            .split("")
                            .map((letter, index1) => {
                              return (
                                <>
                                  <Typography
                                    sx={{
                                      lineHeight: 1,
                                      color: "#DB8829",
                                      boxShadow: "none",
                                      fontSize: "1rem",
                                      fontWeight: "500",
                                      display: "inline-flex",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.4rem",
                                      },
                                    }}
                                  >
                                    {letter}
                                  </Typography>
                                  {index1 <
                                    unicodeToString(val.text).split("").length -
                                      1 && (
                                    <Typography
                                      sx={{
                                        lineHeight: 1,
                                        width: "0.5rem",
                                        boxShadow: "none",
                                        fontSize: "1rem",
                                        fontWeight: "900",
                                        padding: "0px 7px",
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        color: "#0a6c00",
                                        "@media (min-width: 1636px)": {
                                          fontSize: "1.4rem",
                                        },
                                      }}
                                      onClick={() => {
                                        updateUserAnswer(index1, index);
                                      }}
                                    >
                                      {userAnswer &&
                                      userAnswer[index] &&
                                      userAnswer[index].indexOf(index1) != -1
                                        ? "|"
                                        : " "}
                                    </Typography>
                                  )}
                                </>
                              );
                            })}
                        </Grid>
                        {isPresentation && (
                          <Grid
                            item
                            xs={2}
                            sx={{
                              paddingLeft: 2,
                              paddingTop: 1,
                              display: "inline-flex",
                            }}
                          >
                            {(localSubmitButton[index] ||
                              localShowAnswer[index]) && (
                              <Button
                                sx={{
                                  width: "11vw",
                                  textTransform: "inherit",
                                  borderRadius: 10,
                                  boxShadow: 3,
                                  fontWeight: "600",
                                  fontSize: "0.8rem",
                                }}
                                onClick={() => {
                                  internalSubmit(index);
                                }}
                              >
                                {localSubmitButton[index] &&
                                !localShowAnswer[index]
                                  ? "Submit"
                                  : "Answer"}
                              </Button>
                            )}
                          </Grid>
                        )}
                      </Grid>
                    </Box>
                  );
                })}
              </Grid>
            </Grid>
            <Confirmation
              visible={localAlertFlag}
              primaryText={
                !localAttempStatus[localCurrentIndex]
                  ? "Please attempt"
                  : localCorrect[localCurrentIndex]
                  ? "Congratulations !"
                  : "Incorrect"
              }
              image={localCorrect[localCurrentIndex] ? "complete" : "error"}
              alert={true}
              toggleModal={(flag) => setLocalAlertFlag(flag)}
              timeout={3000}
              UX={true}
            ></Confirmation>
          </Box>
        </Grid>
      )}
    </>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "0.9rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default SB;
